import React from 'react';

import SideModal from 'Components-redesign/SideModal';
import ModalHeader from 'Components-redesign/SideModal/Header';
import { useI18n } from 'Hooks';
import { getCompany_company_variations as Variation } from 'Scenes-redesign/PIM/__queries__';
import ModificationGroupForm from 'Scenes-redesign/PIM/Forms/ModificationGroupForm';

interface Props {
  isShowing: boolean;
  variationsList: Variation[];
  closeModal: () => void;
  handleFormSuccess: (node: any) => void;
  idToUpdate?: string;
}

const CreateModificationGroup = ({
  isShowing,
  variationsList,
  closeModal,
  handleFormSuccess,
  idToUpdate,
}: Props) => {
  const { t } = useI18n();

  return (
    <SideModal isOpen={isShowing} closeModal={closeModal}>
      <ModalHeader
        title={t('Pim.Modifications.Group')}
        description={t('Pim.Modifications.Group.Desc')}
      />
      <ModificationGroupForm
        idToUpdate={idToUpdate || undefined}
        variations={variationsList ?? []}
        onFormSuccess={(node) => {
          closeModal();
          handleFormSuccess(node);
        }}
      />
    </SideModal>
  );
};

export default CreateModificationGroup;
